import { usePaymentModalData } from "@faire/deprecated-retailer-visitor-shared/components/PromoModals/hooks/usePaymentModalData";

export const useModalType = () => {
  const { data } = usePaymentModalData();
  return data?.promo_modal_information?.type;
};
